export default "__VITE_ASSET__BjQMWjlP__"